import ToastAlert from "$lib/common/ToastAlert.svelte"
import type { Alert, ComponentTypeProps } from "@tastyworks/ui-library"
import { toast } from "@zerodevx/svelte-toast"

type AlertRootProps = ComponentTypeProps<typeof Alert.Root>

const defaultToastOptions = {
  // defaults direct from svelte-toast docs
  // progress bars are globally hidden in global.css
  classes: [], // user-defined classes
  dismissable: false, // allow dismiss with close button
  duration: 10_000, // duration of progress bar tween to the `next` value
  initial: 1, // initial progress bar value
  intro: { x: 256 }, // toast intro fly animation settings
  next: 0, // next progress value
  pausable: true, // pause progress bar tween on mouse hover
  reversed: false, // insert new toast to bottom of stack
  theme: {
    "--toastWidth": "372px",
    "--toastBackground": "transparent",
    "--toastBarBackground": "transparent",
    "--toastMsgPadding": "0 0 8px 0",
    "--toastBtnContent": "none",
    "--toastBtnWidth": "0",
  }, // css var overrides
}

export function toastAlert(
  variant: AlertRootProps["variant"],
  title = "",
  description = "",
  descriptionItems: string[] = []
) {
  toast.push({
    ...defaultToastOptions,
    component: {
      props: {
        title,
        description,
        descriptionItems,
        variant,
      },
      src: ToastAlert as any,
      sendIdTo: "toastId",
    },
  })
}
